module.exports = __webpack_public_path__ + "img/logo.c12168d3.png";